import Select, { Props as BaseSelectProps, ClearIndicatorProps, GroupBase, OptionProps, components } from 'react-select';
import { SimpleTooltip } from '../simple-tooltip';
import { Option, SelectStyleProps } from './types';
import { DropdownIndicator } from './DropdownIndicator';
import { getStyles } from './utils';

export type SelectProps<T = string | null> = BaseSelectProps<Option<T> | null, false, GroupBase<Option<T> | null>> &
  SelectStyleProps;

const CustomOption = <T = string | null>(props: OptionProps<Option<T> | null, false, GroupBase<Option<T> | null>>) => {
  const { tooltip, id } = props.data ?? {};
  const componentWithId = id ? (
    <div id={id}>
      <components.Option {...props} />
    </div>
  ) : (
    <components.Option {...props} />
  );

  return tooltip ? (
    <SimpleTooltip placement='bottom' text={tooltip}>
      {componentWithId}
    </SimpleTooltip>
  ) : (
    componentWithId
  );
};

const ClearIndicator = <T = string | null>(props: ClearIndicatorProps<T>) => {
  return (
    <components.ClearIndicator {...props}>
      <i className='fal fa-xmark p-0 ml-3 text-md' />
    </components.ClearIndicator>
  );
};

export const SingleSelect = <T = string | null>(props: SelectProps<T>) => {
  const {
    components,
    styles,
    size,
    isTransparent,
    isFlexibleSize,
    hasOptionDivider,
    showDropdownIndicator = true,
    isMenuPortalTargetBody = false,
    showCount=false,
    minWidth,
    backgroundColor,
    isInvalid,
    ...rest
  } = props;
  return (
    <Select
      components={{
        DropdownIndicator: () => (
          <DropdownIndicator
            current={props.value !== null ? 1 : 0}
            limit={rest.options?.length}
            showCount={showCount}
            showDropdownIndicator={showDropdownIndicator}
          />
        ),
        ClearIndicator,
        Option: CustomOption,
        ...components,
      }}
      styles={{
        ...getStyles<Option<T> | null>({
          size,
          isMulti: false,
          isTransparent,
          hasOptionDivider,
          isFlexibleSize,
          isMenuPortalTargetBody,
          minWidth,
          backgroundColor,
          isInvalid
        }),
        ...styles,
      }}
      menuPortalTarget={isMenuPortalTargetBody ? document.body : null}
      {...rest}
    />
  );
};
